import { createReducer, on } from "@ngrx/store";
import {
  LearningResourcesState,
  initialLearningResourceState,
} from "./learning-resource.state";
import {
  AddLearningResources,
  AddLearningResourcesError,
  AddLearningResourcesSuccess,
  GetLearningResourceItems,
  GetLearningResourceItemsError,
  GetLearningResourceItemsSuccess,
  GetLearningResources,
  GetLearningResourcesError,
  GetLearningResourcesSuccess,
  GetModuleType,
  GetModuleTypeSuccess,
  RemoveLearningResources,
  RemoveLearningResourcesError,
  RemoveLearningResourcesSuccess,
  ResetLearningResourcesState,
  ResetLearningResourcesTablesSuccess,
  UpdateActivityDueDate,
  UpdateActivityDueDateError,
  UpdateActivityDueDateSuccess,
  UpdateLearningResources,
} from "./learning-resource.actions";

export const LearningResourcesReducers = createReducer(
  initialLearningResourceState,
  on(ResetLearningResourcesState, (): LearningResourcesState => {
    return initialLearningResourceState;
  }),

  on(ResetLearningResourcesTablesSuccess, (): LearningResourcesState => {
    return initialLearningResourceState;
  }),

  on(GetLearningResources, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(GetLearningResourcesSuccess, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      result: action.result,
    };
  }),
  on(GetLearningResourcesError, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(UpdateLearningResources, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(AddLearningResources, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(AddLearningResourcesSuccess, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      messageResult: action.result,
    };
  }),
  on(AddLearningResourcesError, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(RemoveLearningResources, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(
    RemoveLearningResourcesSuccess,
    (state, action): LearningResourcesState => {
      return {
        ...state,
        loading: false,
        messageResult: action.result,
      };
    }
  ),
  on(RemoveLearningResourcesError, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(UpdateActivityDueDate, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(UpdateActivityDueDateSuccess, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      messageResult: action.result,
    };
  }),
  on(UpdateActivityDueDateError, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      error: action.error,
    };
  }),
  on(GetModuleType, (state): LearningResourcesState => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(GetModuleTypeSuccess, (state, action): LearningResourcesState => {
    return {
      ...state,
      loading: false,
      moduleTypes: action.moduleTypes,
    };
  }),
  on(GetLearningResourceItems, (state): LearningResourcesState => {
    return {
      ...state,
      loadLearningResourceItems: true,
    };
  }),
  on(
    GetLearningResourceItemsSuccess,
    (state, action): LearningResourcesState => {
      return {
        ...state,
        loadLearningResourceItems: false,
        learningResourceItems: action.learningResourceItems,
      };
    }
  ),
  on(GetLearningResourceItemsError, (state, action): LearningResourcesState => {
    return {
      ...state,
      loadLearningResourceItems: false,
      error: action.error,
    };
  })
);
